"use client";

import { Box, Stack, Typography } from "@mui/material";
import QRCode from "qrcode.react";
import type { FC } from "react";
import type { FooterQrCodeProps } from "../lib/type";

export const QrCodeFooter: FC<FooterQrCodeProps> = ({ href, qrCodeLabel, name }) => {
    return (
        <Stack className={"flex flex-col gap-5"}>
            {name && <Typography component={"h3"}>{name}</Typography>}
            <Stack
                className={
                    "flex-center-row justify-between bg-[#4c5f8d] min-w-[232px] rounded-[8px]"
                }
            >
                <Box className={"my-0 mx-auto text-center"}>
                    <Typography className={"text-sm text-white"}>{qrCodeLabel}</Typography>
                </Box>
                <Box className={"flex rounded-[8px] overflow-hidden"}>
                    <QRCode value={href} size={116} />
                </Box>
            </Stack>
        </Stack>
    );
};
